const LeagueScorersPageReducer = (state, action) => {
  switch (action.type) {
    case 'LEAGUE_SCORERS_META_LEAGUE_UPDATE':
      return {...state, metaLeague: action.data};
    case 'LEAGUE_SCORERS_FETCHING':
      return {...state, isFetching: true};
    case 'LEAGUE_SCORERS_UPDATE':
      const LeagueScorersPage = {...state};
      LeagueScorersPage.scorers = LeagueScorersPage.scorers.concat(action.data.scorers);
      LeagueScorersPage.nextUrl = action.data.nextUrl;
      LeagueScorersPage.isFetching = false;
      return LeagueScorersPage;
    case 'LEAGUE_SCORERS_ERROR':
      return {...state, error: action.data, isFetching: false, nextUrl: null};
    default:
      return state;
  }
};

export {LeagueScorersPageReducer};
